module.exports = __webpack_public_path__ + "img/15.358e50b3.png";